import { useExtendWithSubnetworks, useNetworksStateContext } from "@l2r-front/l2r-networks"

import { API_MODULE_ROADSIDE } from "../../../../common/constants/appRoad"

import { roadsideQueryKeys } from "./queryKeys"
import { useRoadsideQuery } from "./useRoadsideQuery"

export function useRoadsideHomogenousZones(parameters = {}, config = {}) {
    const url = "homogeneous_roadside_inventories/"
    const { selectedNetwork } = useNetworksStateContext()

    const queryParameters = useExtendWithSubnetworks({
        ...parameters,
        project: selectedNetwork.slug,
    }, API_MODULE_ROADSIDE)

    const queryKey = roadsideQueryKeys["homogenousZones"](queryParameters)

    return useRoadsideQuery(
        url,
        queryKey,
        queryParameters,
        {
            enabled: !!selectedNetwork,
            ...config,
        },
    )
}